<template>
  <div class="tabla-errores">
    <h6 class="titulo-tabla mb-3">Registros con errores</h6>
    <div class="tabla-scroll">
      <b-table-simple hover small>
        <b-thead>
          <b-tr>
            <b-th>Fila</b-th>
            <b-th>Motivo del error</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(error, index) in errores" :key="index">
            <b-td class="font-weight-bold"># {{ error.fila }}</b-td>
            <b-td>{{ error.motivo }}</b-td>
          </b-tr>
          <b-tr v-if="errores.length === 0">
            <b-td colspan="2" class="text-center text-muted py-4">
              <i class="fa fa-check-circle text-success mr-2"></i> No hay errores para mostrar
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablaErrores',
  props: {
    errores: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.tabla-errores {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.2rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.02);
}

.titulo-tabla {
  color: #495057;
  font-weight: 700;
}

.tabla-scroll {
  max-height: 250px;
  overflow-y: auto;
}

.tabla-scroll table {
  margin-bottom: 0;
}

.tabla-scroll th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>